  import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet, } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = environment.appTitle;

  constructor(private readonly titleService: Title) {
    this.setTitle();
  }

  private setTitle() {
    this.titleService.setTitle(this.title);
  }
}
